/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { Roles } from '../UNSAFE_ListView';
import { HTMLAttributesSignalExcluded } from '../utils/UNSAFE_attributeUtils';

/**
 * List Roles need to be kept in matching sets, this module encapsulates the sets
 *
 * @param ariaRole
 * @returns matching, valid set of roles
 */

const getListViewRoles = (
  ariaRole: Roles
): {
  list: HTMLAttributesSignalExcluded['role'];
  item: HTMLAttributesSignalExcluded['role'];
  cell: HTMLAttributesSignalExcluded['role'];
} => {
  switch (ariaRole) {
    case 'listbox':
      return { list: 'listbox', item: 'presentation', cell: 'option' };
    case 'treegrid':
      return { list: 'treegrid', item: 'row', cell: 'gridcell' };
    default:
      return { list: 'grid', item: 'row', cell: 'gridcell' };
  }
};

export { getListViewRoles };
